import { Box, Button, Stack } from '@mui/material'

import { useActions } from '../hooks/useActions'
import { useController } from '../hooks/useController'
import { useTexts } from '../useTexts'

export function Footer() {
  const texts = useTexts()
  const {
    data: { canDiscard, discarding },
  } = useController()
  const { requestDiscard } = useActions()

  if (!canDiscard) {
    // Reserve the footer height so the layout doesn't jump when Discard appears
    return (
      <Box
        component="footer"
        sx={{
          px: 3,
          py: 2,
          borderTop: t => `1px solid ${t.vars.palette.divider}`,
          minHeight: 56,
        }}
      />
    )
  }

  return (
    <Box
      component="footer"
      sx={{
        px: 3,
        py: 2,
        borderTop: t => `1px solid ${t.vars.palette.divider}`,
      }}
    >
      <Stack direction="row" justifyContent="flex-end">
        <Button
          variant="text"
          onClick={requestDiscard}
          disabled={discarding}
          data-testid="build-progress__discard"
        >
          {texts.discardOptimization}
        </Button>
      </Stack>
    </Box>
  )
}
